import { render, staticRenderFns } from "./PstImport.vue?vue&type=template&id=108533f8&scoped=true&"
import script from "./PstImport.vue?vue&type=script&lang=js&"
export * from "./PstImport.vue?vue&type=script&lang=js&"
import style0 from "./PstImport.vue?vue&type=style&index=0&id=108533f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108533f8",
  null
  
)

export default component.exports